import { useGlobalState } from "@/context/GlobalStateContext";
import React from "react";
import "./Privacy.scss";

const Paylater = () => {
  const { language } = useGlobalState();
  return (
    <>
      {language === "ru" ? (
        <div className="privacy__content">
          <h1 className="privacy__title">
            Публичная оферта ООО МФО «Paylater» о предоставлении онлайн
            микрозайма посредством электронной системы «Paylater»
          </h1>

          <h2 className="privacy__subtitle">1. Термины и определения</h2>

          <p>
            1.1. Система «Paylater» – комплекс программно-технических средств,
            включая сайт «www.paylater.uz», размещённый в сети интернет по
            адресу: www.paylater.uz, предоставляющий возможность пользоваться
            услугами микрофинансовой организации ООО МФО «PAYLATER» (далее –
            МФО) дистанционно.
          </p>
          <p>
            1.2. Клиент — физическое лицо, гражданин Республики Узбекистан,
            постоянно проживающий в Республике Узбекистан, намеренный получить
            Микрозайм посредством Системы Paylater.
          </p>
          <p>
            1.3. Заемщик — лицо, получившее через Систему Paylater Микрозайм для
            приобретения товаров, оплаты работ и услуг, на условиях,
            предусмотренных настоящей Публичной офертой.
          </p>
          <p>
            1.4. Индивидуальные условия кредита — конкретные условия
            предоставления Микрозайма Клиенту (сумма, срок, иные платежи и
            т.п.), в пределах рассчитанной МФО суммы возможного финансирования,
            подтверждённые Клиентом при получении Микрозайма.
          </p>
          <p>
            1.5. Кредитная заявка — электронное сообщение, формируемое в Системе
            Paylater и направляемое Клиентом в МФО с целью оценки вероятности
            предоставления ему Микрозайма, содержащее общую информацию о
            запрашиваемом Микрозайме на условиях, предусмотренных настоящей
            Публичной офертой.
          </p>
          <p>
            1.6. Микрозайм — денежные средства, предоставляемые МФО Заёмщику на
            условиях срочности, возвратности и платности посредством
            использования Системы Paylater, путём зачисления денежных средств на
            условиях, предусмотренных настоящей Публичной офертой.
          </p>
          <p>
            1.7. Торговая организация (ТО) — предприятие сферы торговли и услуг,
            принимающее платежи от МФО в счёт оплаты за товар или услугу от
            Заёмщика.
          </p>

          <h2 className="privacy__subtitle">2. Основные положения</h2>

          <p>
            2.1. Настоящая Публичная оферта является официальным предложением
            МФО, адресованным неопределённому количеству Клиентов, заключить с
            МФО договор о предоставлении Микрозайма посредством Системы Paylater
            на условиях настоящей Публичной оферты.
          </p>
          <p>
            2.2. Договор о предоставлении Микрозайма заключается в соответствии
            со статьёй 367 и частью 2 статьи 369 Гражданского кодекса Республики
            Узбекистан и приобретает силу с момента совершения Клиентом
            действий, предусмотренных в настоящей Публичной оферте, означающих
            безоговорочный акцепт Клиентом условий настоящей Публичной оферты
            без каких-либо изъятий или ограничений.
          </p>
          <p>
            2.3. При согласии с условиями настоящей Публичной оферты Клиент
            может акцептовать её в режиме онлайн с использованием средств
            Системы Paylater или иными способами, установленными МФО. Данный
            акцепт является для МФО основанием для предварительного рассмотрения
            кредитной заявки Клиента как потенциального Заемщика. В случае
            одобрения МФО кредитной заявки Клиента МФО направляет Клиенту
            Индивидуальные условия кредита.
          </p>
          <p>
            2.4. Индивидуальные условия кредита устанавливаются отдельно перед
            каждым получением Клиентом Микрозайма и передаются через систему
            Paylater. Заемщик принимает и соглашается с Индивидуальными
            условиями кредита путём ввода кода, полученного из SMS-сообщения,
            либо другим предложенным МФО способом. В случае акцепта Заемщиком
            настоящей Публичной оферты и принятия Индивидуальных условий кредита
            договор о предоставлении Микрозайма (далее — Договор) на условиях
            настоящей Публичной оферты и Индивидуальных условий кредита
            считается заключённым.
          </p>
          <p>
            2.5. Клиент соглашается, что скоринговая модель МФО, посредством
            которой осуществляется оценка кредитоспособности и других данных
            Клиента, является коммерческой тайной и считается конфиденциальной.
          </p>
          <p>
            2.6. С целью ознакомления Клиента с настоящей Публичной офертой (в
            том числе с периодически вносимыми МФО изменениями и/или
            дополнениями) МФО публикует указанные документы на сайте МФО.
            Дополнительно МФО может информировать Клиента иными способами,
            позволяющими установить, что информация исходит от МФО. Датой
            публикации считается дата её первого размещения на сайте МФО.
          </p>
          <h2 className="privacy__subtitle">3. Предмет договора</h2>

          <p>
            3.1. МФО предоставляет Заемщику Микрозайм на потребительские цели, в
            том числе на покупку товаров и оплату услуг (работ) в сумме,
            указанной в Индивидуальных условиях кредита, а Заемщик обязуется
            вернуть МФО полученную сумму Микрозайма в соответствии с условиями
            настоящей Публичной оферты и Индивидуальными условиями кредита.
          </p>

          <h2 className="privacy__subtitle">4. Порядок выдачи микрозайма</h2>

          <p>
            4.1. Микрозайм предоставляется Заемщику на условиях и в порядке,
            установленном настоящей Публичной офертой и Индивидуальными
            условиями кредита, путём зачисления денежных средств в безналичной
            форме на расчётный счёт Торговой организации в течение 15
            (Пятнадцати) банковских дней с даты акцепта Индивидуальных условий
            кредита и подтверждения отгрузки товара через систему Paylater.
          </p>
          <p>
            4.2. Для получения Микрозайма Заемщик должен в интерфейсе системы
            Paylater ознакомиться и акцептовать (принять) настоящую Публичную
            оферту и направить Кредитную заявку с запросом о возможности
            предоставления Микрозайма.
          </p>
          <p>
            4.3. Клиент вправе подать Кредитную заявку в сумме, не превышающей
            предложенную МФО сумму возможного финансирования на условиях
            настоящей Публичной оферты.
          </p>
          <p>
            4.4. Кредитная заявка Клиента должна содержать сумму, срок и число
            месяца погашения Микрозайма и является неотъемлемой частью настоящей
            Публичной оферты, акцептованной Клиентом.
          </p>
          <p>
            4.5. После обработки Кредитной заявки МФО сообщает Клиенту в
            интерфейсе системы Paylater об её одобрении путём направления
            Индивидуальных условий кредита, содержащих предоставляемую сумму,
            срок и график погашения Микрозайма, либо о невозможности
            предоставления Микрозайма.
          </p>
          <p>
            4.6. Акцептуя настоящую Публичную оферту и Индивидуальные условия
            кредита, Клиент выражает согласие и уполномочивает МФО запрашивать,
            получать, обрабатывать и передавать персональные данные Клиента в
            необходимом объёме и в неограниченном количестве раз от официальных
            и иных источников в соответствии с Законом Республики Узбекистан «О
            персональных данных» и законодательством о небанковских кредитных
            организациях, в целях, связанных с рассмотрением, предоставлением и
            погашением Микрозайма.
          </p>
          <p>
            4.7. Одобренная МФО сумма финансирования Клиента определяется на
            основе имеющейся у МФО и/или запрашиваемой информации о Клиенте
            посредством оценки кредитоспособности Клиента. Методика оценки
            кредитоспособности Клиента является коммерческой тайной МФО и
            считается конфиденциальной.
          </p>
          <p>
            4.8. Подача Кредитной заявки и акцепт Индивидуальных условий кредита
            является подтверждением согласия Клиента на получение Микрозайма,
            указанного в Индивидуальных условиях кредита.
          </p>
          <p>
            4.9. Обязательство МФО по предоставлению Микрозайма считается
            исполненным с Даты предоставления Микрозайма.
          </p>

          <h2 className="privacy__subtitle">5. Порядок погашения микрозайма</h2>

          <p>
            5.1. Погашение (возврат) основного долга по Микрозайму
            осуществляется Заемщиком в валюте Микрозайма согласно Индивидуальным
            условиям кредита.
          </p>
          <p>
            5.2. Заемщик обязуется погашать полученный Микрозайм в соответствии
            со сроками, указанными в графике платежей, размещённом в системе
            Paylater.
          </p>
          <p>
            5.3. Средства, поступающие на погашение Микрозайма Заемщика,
            направляются на погашение основного долга по Микрозайму.
          </p>
          <p>
            5.4. Частичное досрочное погашение задолженности по Договору не
            влечёт изменение количества, порядка определения размера и
            периодичности (сроков) платежей Заемщика по Индивидуальным условиям.
            Суммы, уплаченные Заемщиком сверх установленных графиком платежей,
            направляются на досрочное погашение задолженности по основному
            долгу.
          </p>
          <p>
            5.5. Срочная задолженность (задолженность, дата погашения которой не
            наступила, либо досрочное погашение Микрозайма) погашается согласно
            указаниям Заемщика.
          </p>
          <p>
            5.6. Погашение Микрозайма производится путём перечисления денежных
            средств на счёт МФО, указанный в настоящей Публичной оферте. Датой
            погашения Микрозайма считается день поступления средств на указанный
            счёт.
          </p>
          <p>
            5.7. При наступлении просроченной задолженности, в целях исполнения
            своих обязательств перед МФО, Клиент, акцептуя Публичную оферту,
            даёт МФО своё согласие на безакцептное списание денежных средств со
            всех счетов Клиента (включая банковские пластиковые карты).
          </p>
          <h2 className="privacy__subtitle">
            6. ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ
          </h2>

          <p>
            6.1. Заключая Договор, а также направляя в МФО кредитную заявку,
            Клиент/Заемщик предоставляет МФО право (согласие) неограниченное
            количество раз осуществлять обработку предоставленных Клиентом
            персональных данных на бумажных и/или электронных носителях с
            использованием и/или без использования средств автоматизации сбора,
            записи, систематизации, накопления, хранения, уточнения (обновления,
            изменения), извлечения, использования, передачи (предоставления,
            доступа, в том числе при поручении обработки персональных данных
            третьим лицам), обезличивание, блокирование, удаление, уничтожение
            персональных данных Клиента/Заемщика.
          </p>

          <p>
            6.2. Для целей настоящего Договора под персональными данными
            Клиента/Заемщика понимается предоставленная любым возможным способом
            МФО Клиентом/Заемщиком или с его согласия третьим лицом информация,
            относящаяся к прямо или косвенно определенному или определяемому с
            ее помощью Клиенту/Заемщику, в том числе следующие сведения:
            фамилия, имя, отчество; дата, месяц и год рождения; пол; контактные
            данные (номера телефонов, адреса электронной почты); данные
            документа, удостоверяющего личность; сведения о месте проживания
            и/или месте пребывания; сведения об образовании, семейном положении,
            количестве детей, о занятости и сфере деятельности, сведения о
            работодателе, о среднемесячном доходе и ежемесячных расходах и т.п.
          </p>

          <p>
            6.3. Обработка вышеуказанных персональных данных Клиента разрешается
            в следующих целях: рассмотрение МФО возможности заключения с
            Клиентом Договора, положительное или отрицательное решение по
            вопросу заключения которого может быть принято МФО, в том числе
            путем исключительно автоматизированной обработки персональных данных
            Клиента/Заемщика; проверка достоверности указанных
            Клиентом/Заемщиком сведений; исполнение и прекращение Договора;
            истребование (погашение, взыскание) задолженности по Договору;
            оценка платежеспособности Клиента/Заемщика; поиск и проверка его
            места работы, фактического адреса проживания, телефона и других
            данных, полученных от Клиента/Заемщика; выявление интереса
            Клиента/Заемщика к продуктам МФО; отнесение Клиента/Заемщика к
            маркетинговым сегментам; продвижение и оказание (предоставление)
            Клиенту/Заемщику иных услуг и продуктов МФО (включая в том числе
            рассмотрение МФО возможности заключения иных договоров, связанных с
            оказанием иных предоставляемых МФО услуг).
          </p>

          <p>
            6.4. Заключая Договор Клиент дает безотзывное и полное согласие МФО
            в любое время и неограниченное количество раз запрашивать данные о
            его кредитной истории в бюро кредитных историй в целях получения от
            МФО персональных предложений продуктов на специальных условиях в
            течение всего срока действия соответствующего Договора согласно
            Закону Республики Узбекистан «Об обмене кредитной информацией».
          </p>
          <h2 className="privacy__subtitle">7. Права и обязанности сторон</h2>

          <h3 className="privacy__subtitle">Заемщик имеет право:</h3>
          <ul>
            <li>
              7.1. На погашение Микрозайма раньше сроков, установленных
              настоящим Договором, в любое время, без взыскания штрафных
              санкций.
            </li>
            <li>
              7.2. На бесплатной основе отказаться от получения Микрозайма до
              зачисления денежных средств.
            </li>
            <li>
              7.3. В период действия Договора раз в месяц в течение одного
              рабочего дня на бесплатной основе получать в письменной форме
              следующую информацию:
              <ul>
                <li>О сумме денежных средств, уплаченных по Микрозайму;</li>
                <li>Об остатке долга по основной сумме;</li>
                <li>
                  О размере, составе и сроках очередных платежей (график
                  платежей);
                </li>
                <li>О размере и составе просроченной задолженности;</li>
                <li>
                  О направлении поступающих денежных средств на погашение
                  задолженности по Микрозайму.
                </li>
              </ul>
              Клиент принимает условие, что обмен такого рода сообщениями
              производится в электронной форме средствами системы Paylater,
              которые приравниваются к документу на бумажном носителе и имеют
              одинаковую с ним юридическую силу.
            </li>
            <li>
              7.4. Отказаться от неиспользованной суммы Микрозайма в течение
              двух недель со дня заключения Договора о предоставлении Микрозайма
              путём письменного уведомления об этом МФО.
            </li>
          </ul>

          <h3 className="privacy__subtitle">Заемщик обязуется:</h3>
          <ul>
            <li>
              7.5. Погашать задолженность и производить оплату всех платежей в
              сроки, установленные Договором. При возврате Заемщиком товара
              Торговой организации, стоимость товара возвращается на счет МФО в
              счет погашения задолженности по Микрозайму. Денежные средства,
              поступившие на счет/карту Заемщика в результате их возврата
              Торговой организацией, должны быть самостоятельно направлены
              Заемщиком в счет погашения задолженности по Микрозайму.
            </li>
            <li>
              7.6. По запросу МФО предоставить любые документы, подтверждающие
              финансовое и имущественное положение, в течение 3-х рабочих дней с
              момента получения соответствующего запроса.
            </li>
            <li>
              7.7. В случае изменения Ф.И.О., места проживания, места работы,
              индивидуальных сведений, персональных или биографических данных
              либо иной информации сообщить об этих изменениях МФО в течение
              одного дня с момента таких изменений.
            </li>
            <li>
              7.8. Не принимать на себя обязательств и мер, которые могут
              привести к ухудшению финансового состояния и угрозе невыполнения
              или ненадлежащего исполнения обязательств перед МФО по Договору.
            </li>
            <li>
              7.9. Предоставлять возможность проверять и перепроверять МФО, его
              работниками, правопреемниками и привлечёнными аутсорсинговыми
              компаниями данные, предоставленные Клиентом/Заемщиком, с
              использованием любых источников информации, включая сведения,
              указанные в Кредитной заявке и документах для получения
              Микрозайма, в том числе путём посещения места жительства, работы и
              т.п.
            </li>
            <li>
              7.10. По требованию МФО возместить все расходы и убытки,
              понесённые МФО, включая меры по принудительному и/или досрочному
              взысканию задолженности по Микрозайму (основной долг и прочие
              платежи), предоставляемые в рамках настоящего Договора.
            </li>
            <li>
              7.11 Клиент не вправе полностью или частично переуступать свои
              права и обязательства по Микрозайму другому лицу без согласия МФО.
            </li>
          </ul>

          <h3 className="privacy__subtitle">МФО имеет право:</h3>
          <ul>
            <li>
              7.12. В процессе кредитования проверять финансовое состояние
              Клиента/Заемщика. Периодичность проверок устанавливается МФО.
            </li>
            <li>
              7.13. В случае наступления обстоятельств, предусмотренных в п.
              7.14. настоящей Публичной оферты МФО имеет право: - досрочно
              прекратить предоставление Микрозайма по Договору в одностороннем
              порядке (если Микрозайм был предоставлен частично), уведомив об
              этом Заемщика в сроки, установленные действующим законодательством
              и/или предъявить Микрозайм к досрочному взысканию (потребовать
              досрочной полной оплаты задолженности по Микрозайму). Датой
              направления письменного уведомления считается дата его вручения
              Заемщику или дата почтового отправления; - взыскать как
              просроченную, так и полную задолженность по Микрозайму через
              судебные органы, в том числе посредством получения судебного
              приказа. Датой направления письменного уведомления считается дата
              его вручения Заемщику или дата почтового отправления; - взыскать
              как просроченную, так и полную задолженность по Микрозайму через
              органы нотариата, путем получения исполнительной надписи; - по
              своему единоличному абсолютному усмотрению начать судебные
              процедуры по принудительному исполнению обязательств по Договору,
              не связанных с осуществлением платежей по Микрозайму;- прекратить
              выдачу новых сумм по Договору и/или новых Микрозаймов;
            </li>
            <li>
              Наступление следующих обстоятельств дает МФО право совершить
              действия (реализовать права), предусмотренные п. 7.13. настоящей
              Публичной оферты:
              <ul>
                <li>
                  Использование Микрозайма не по целевому назначению и/или не
                  предоставления возможности и/или документов для проведения
                  сотрудниками МФО проверки целевого использования Микрозайма;
                </li>
                <li>
                  Невыполнение Заёмщиком обязательств по погашению какой-либо
                  задолженности по Микрозайму (основной долг, штрафы, комиссии и
                  другие платежи), либо по какому - то другому обязательству
                  перед МФО, наличии непогашенной просроченной задолженности по
                  данной Микрозайму и/или ранее полученным Микрозаймам (займам);
                </li>
                <li>
                  Нарушение и/или неисполнение и/или ненадлежащее исполнение
                  Заемщиком принятых на себя обязательств по Договору, а также
                  по другим договорам, заключенным с МФО;- ухудшение финансового
                  состояния Заемщика, в т.ч. отсутствие источника дохода;
                </li>
                <li>
                  Предоставление Заёмщиком недостоверных или ложных сведений или
                  отказ от предоставления сведений, запрошенных МФО, в том числе
                  для осуществления мониторинга кредита, финансового состояния
                  Заёмщика;
                </li>
                <li>
                  Объявление какой-либо задолженности Заёмщика перед другими
                  кредиторами к погашению или на ином основании становится
                  подлежащей погашению до первоначального срока ее погашения;
                </li>
                <li>
                  Обращение взыскания на имущество Заёмщика или наложения на
                  него ареста со стороны третьих лиц;
                </li>
                <li>
                  Образование необеспеченной части задолженности по Микрозайму;
                </li>
                <li>
                  Возникновение событий, которые, по мнению МФО, могут серьезно
                  повлиять на выполнение платежных обязательств по Микрозайму
                  и/или появления каких-либо факторов, увеличивающих риск
                  невозврата Микрозайма;
                </li>
                <li>
                  Если в отношении Заёмщика возбуждено уголовное дело либо
                  судебное дело или если на имущество Заемщика в обеспечение
                  покрытия долга наложен арест или если имело место быть
                  замораживание и/или приостановление операций с денежными
                  средствами или иным имуществом Заемщика;
                </li>
                <li>
                  Наличия подозрений о том, что целью заключения и использования
                  Договора является легализация доходов, полученных от
                  преступной деятельности, финансирования терроризма и
                  финансирования распространения оружия массового уничтожения;
                </li>
                <li>
                  Предъявлен иск об уплате денежной суммы и/или об истребовании
                  имущества Заемщика и/или - наложения ареста со стороны третьих
                  лиц, размер которого ставит под угрозу выполнение Заемщиком
                  обязательств по Договору.
                </li>
              </ul>
            </li>
            <li>
              7.15. МФО по своему усмотрению может применять либо не применять
              любое из прав/требований, указанных в настоящей Публичной оферте.
              Неприменение либо частичное применение этих прав/требований не
              будет означать отказа от этих прав/требований, и они могут быть
              применены в любое время в течение срока действия Договора.
            </li>
            <li>
              7.16. МФО имеет право связываться с Клиентом и направлять ему
              оповещения и уведомления о наличии просроченной задолженности и
              неисполнении обязательств по Договору с помощью средств связи и на
              адреса (телефоны), указанные в кредитной заявке, и в прочих
              документах, предоставленных Клиентом в МФО для получения
              Микрозайма, а также по контактным данным, полученным от Клиента, в
              т.ч. путем телефонной связи, отправки SMS уведомления на
              телефонный номер, через почтовую службу по адресу постоянной
              регистрации/фактического проживания, по электронной почте, или
              любыми другими средствами связи, а также путём посещения Клиента
              по указанному адресу постоянной регистрации/фактического
              проживания/места работы.
            </li>
            <li>
              7.17. МФО вправе полностью или частично переуступать свои права и
              обязательства по Договору другому лицу без согласия Заемщика.
            </li>
            <li>
              7.18. МФО при наступлении просроченной задолженности со стороны
              клиента, в целях исполнения обязательств перед МФО вправе в
              безакцептном порядке списывать сумму просроченной задолженности с
              любого счета (банковской пластиковой карты) для погашения
              задолженности.
            </li>
          </ul>
          <h3 className="privacy__subtitle">МФО обязуется:</h3>
          <ul>
            <li>
              7.19. Предоставлять Заемщику возможность пользоваться Микрозаймом
              в пределах лимита и в сроки, оговоренные в Публичной оферте и
              Индивидуальных условиях;
            </li>
            <li>
              7.20. В целях взыскания задолженности по Микрозайму, извещать в
              установленной форме Заемщика о необходимости погашения
              задолженности и последствиях невыполнения обязательств по
              Микрозайму в течение 10 (Десяти) календарных дней с даты
              возникновения просроченной задолженности, используя один из
              следующих способов связи : путем SMS информирования/PUSH-
              уведомлений на номер мобильного телефона, предоставленный
              Клиентом, а также направлением по адресу Заемщика, приведенного в
              Договоре, письменного требования о необходимости погашения
              просроченной задолженности. Нарочное вручение извещения и устное
              напоминание об этом по телефону не осуществляется в период с 20:00
              часов до 8:00 часов по местному времени.
            </li>
            <li>
              7.21. В случае полного исполнения обязательств по Договору в
              течение одного рабочего дня со дня поступления в МФО
              соответствующего запроса Клиента предоставить документ в
              письменном виде, подтверждающий полное исполнение Клиентом
              обязательств по Договору.
            </li>
            <li>
              7.22. В течение десяти рабочих дней со дня регистрации в МФО
              соответствующего запроса Заемщика предоставить документ,
              подтверждающий предоставление Микрозайма Клиенту.
            </li>
          </ul>
          <h2 className="privacy__subtitle">8. Ответственность сторон</h2>
          <p>
            8.1. Стороны несут ответственность за неисполнение или ненадлежащее
            исполнение своих обязательств по Договору в соответствии с условиями
            Договора и действующим законодательством.
          </p>
          <p>
            8.2. Стороны освобождаются от ответственности за полное или
            частичное неисполнение своих обязательств по Договору, если
            неисполнение будет являться следствием обстоятельств непреодолимой
            силы, то есть чрезвычайных и непредотвратимых при данных условиях
            обстоятельств. Действие обстоятельств непреодолимой силы Стороны
            должны подтверждать документами компетентных органов. К таким
            обстоятельствам будут относиться, в том числе, военные действия,
            массовые беспорядки, стихийные бедствия, изменения
            военно-политической ситуации, отключение электроэнергии, забастовки,
            решения органов государственной власти и местного самоуправления
            издание законов и иных нормативных актов, делающие невозможным
            исполнение обязательств, предусмотренных настоящей Публичной
            офертой.
          </p>
          <p>
            8.3. При этом Стороны осознают и соглашаются, что пандемия
            коронавирусной инфекцией (COVID-19) и (или) вспышек любых других
            эпидемий или заболеваний, а также вводимые в связи с пандемией
            ограничительные меры (в т.ч. объявление карантина в Республике
            Узбекистан), не может быть признано «обстоятельством непреодолимой
            силы» (форс-мажор) по настоящему Договору и Стороны исключают
            применение правил о непреодолимой силе согласно ч. 3 статьи 333
            Гражданского кодекса Республики Узбекистан с учётом её
            диспозитивности. Действие настоящего пункта Договора применяется
            даже в случае принятия государственными органами действий или
            решений, устанавливающих ограничения для надлежащего исполнения
            обязательств Сторонами по Договору, которые Стороны не могли ни
            предвидеть и/или ни предотвратить разумными мерами.{" "}
          </p>
          <p>
            8.4. Клиент отвечает перед МФО всем своим имуществом за
            своевременность и полноту возврата Микрозайма и других платежей по
            нему, а также возмещение судебных издержек по взысканию долга и
            других убытков МФО, вызванных неисполнением или ненадлежащим
            исполнением обязательств Клиентом.
          </p>
          <p>
            8.5. В случае несвоевременного зачисления суммы Микрозайма полностью
            либо частично согласно условиям Договора, Заемщик вправе взыскать с
            МФО пеню в размере 0,01% от суммы просроченного обязательства, но не
            более 10% от суммы просроченного обязательства.
          </p>
          <p>
            8.6. МФО не несет ответственности за возникновение конфликтных и
            спорных ситуаций вне сферы его контроля.
          </p>
          <p>
            8.7. МФО не несет ответственности за невыполнение или
            несвоевременное выполнение настоящих условий Публичной оферты, в
            случае технических сбоев (отключения/повреждения электропитания и
            сетей связи, технических сбоев в работе Платежных систем), в случае
            некорректного/ неполного указания Клиентом реквизитов для
            перечисления денежных средств на счет.
          </p>
          <p>
            8.8. МФО имеет право начислять и взыскивать проценты, комиссии, пени
            в сумме, составляющей не более половины размера заимствования в год.
          </p>
          <h2 className="privacy__subtitle">
            9. Порядок разрешения споров и обработки обращений
          </h2>
          <p>
            9.1. Все споры, возникающие в процессе исполнения сторонами
            настоящего Договора, будут в предварительном порядке рассматриваться
            сторонами в целях выработки взаимоприемлемого решения. В случае,
            если стороны не пришли к соглашению, все споры, разногласия,
            требования или претензии, которые могут возникнуть или возникли из
            настоящего Договора или в связи с ним, в том числе касающиеся его
            заключения, изменения, исполнения, нарушения, расторжения,
            прекращения, недействительности, незаключенности или истребования
            обеспечения (полностью и/или части) по Договору подлежат
            разрешению:{" "}
          </p>
          <ul>
            <li>В Мирабадском межрайонном суде по гражданским делам;</li>
            <li>
              Либо в Третейском суде при обществе с ограниченной
              ответственностью «CONSILIO» в соответствии с его Регламентом
              единоличным третейским судьей. Решение Третейского суда является
              окончательным и обязательным для сторон;{" "}
            </li>
            <li>
              {" "}
              Либо во внесудебном/досудебном порядке, в том числе путем
              получения нотариальной исполнительной надписи. При взыскании
              задолженности путем получения нотариальной исполнительной надписи,
              Заемщик признает действительность нотариальной исполнительной
              надписи в бесспорном порядке. Право выбора обращения с иском в
              один из вышеуказанных судов или разрешения спора во
              внесудебном/досудебном порядке остается за истцом.
            </li>
          </ul>
          <p>
            9.2. МФО обязуется за 10 дней до обращения в судебные органы
            направить требование о погашении образовавшейся просроченной
            задолженности. В случае неисполнения либо ненадлежащего исполнения
            требования со стороны Заемщика в сроки, указанные в требовании, МФО
            получает право обращения с иском в судебные органы.
          </p>
          <p>
            9.3. МФО вправе требовать возврата непогашенных средств по
            Микрозайму и оплаты всех начисленных процентов и других
            дополнительных требований, а также возмещения Клиентом всех убытков
            и ущербов, нанесенных МФО Клиентом.
          </p>
          <p>
            9.4. Уплата неустойки не освобождает Заемщика от выполнения
            возложенных на него обязательств или устранения нарушений.
          </p>
          <p>
            9.5. Меры ответственности Заемщика и МФО, не предусмотренные в
            настоящей Публичной оферте, применяются в соответствии с
            законодательством Республики Узбекистан.
          </p>
          <h2 className="privacy__subtitle">
            10. Порядок изменения и расторжения договора
          </h2>
          <p>
            10.1. Договор может быть расторгнут по инициативе Клиента в любой
            момент при условии окончательного расчета с МФО и полного погашения
            задолженности при предоставлении в МФО Заявления на расторжение
            Договора.
          </p>
          <p>
            10.2. Договор может быть расторгнут по инициативе МФО в
            одностороннем внесудебном порядке в случае невыполнения Клиентом
            обязательств по Договору, при этом Договор считается расторгнутым
            через 3 (три) дня со дня направления МФО уведомления Заемщику о
            таком расторжении.
          </p>
          <p>
            10.3. Расторжение Договора не влечет прекращения обязанности
            Заемщика погасить перед МФО Задолженность по Договору, включая
            задолженность по оплате комиссий МФО, возникшей в период действия
            Договора.
          </p>
          <h2 className="privacy__subtitle">11. Срок действия договора</h2>
          <p>
            11.1. Договор вступает в силу с момента акцепта Клиентом
            Индивидуальных условийкредита и действует до полного исполнения
            сторонами своих обязательств
          </p>
          <h2 className="privacy__subtitle">12. Заключительные положения</h2>
          <p>
            12.1. Условия, не оговоренные настоящей Публичной офертой,
            регулируются в соответствии с действующим законодательством
            Республики Узбекистан.
          </p>
          <p>
            12.2. Клиент/Заемщик выражает свое согласие на получение от МФО
            рекламных материалов, связанных с продвижением услуг МФО, путем
            осуществления прямых контактов с использованием всех средств связи,
            включая, но не ограничиваясь: почтовая рассылка, СМС-рассылка,
            голосовая рассылка, рассылка электронных писем и т.д.
          </p>
          <p>
            12.3. В случае возникновения споров банковские записи будут являться
            преимущественным доказательством обязательств обеих сторон по
            настоящей Публичной оферте/Договору.
          </p>
          <p>
            12.4. В случае смерти Заемщика, все его права и обязанности
            переходят к его наследникам в порядке, установленном
            законодательством Республики Узбекистан.
          </p>
          <p>
            12.5. Публичная оферта считается действительной с момента и в
            течение срока ее опубликования в системе Paylater /на сайте МФО.
          </p>
          <h2 className="privacy__subtitle">13. Конфиденциальность</h2>
          <p>
            13.1. Стороны обязуются обеспечить конфиденциальность сведений, в
            том числе согласно законодательству о банковской и коммерческой
            тайне
          </p>
          <p>
            13.2. Стороны обмениваются информацией, обоснованно необходимой
            каждой из Сторон для выполнения своих обязательств по настоящему
            договору. Вся письменная или устная информация, относящаяся к
            выполнению обязательств по настоящему договору, предоставляемая
            одной Стороной другой Стороне, является конфиденциальной, будет
            считаться и настоящим определяться как конфиденциальная информация.
            К конфиденциальной информации относятся, в том числе все сведения,
            указанные в настоящем договоре. Конфиденциальная информация подлежит
            защите от несанкционированного доступа к ней, обеспечению её
            целостности, сохранности и своевременного предоставления. Сторона,
            получающая Конфиденциальную информацию в соответствии с настоящим
            договором («Получающая сторона») без предварительного получения
            письменного согласия Стороны, предоставляющей такую информацию
            («Передающая сторона»), не будет:
          </p>
          <ul>
            <li>
              Использовать какую-либо часть Конфиденциальной информации для
              целей, не предусмотренных настоящим договором;
            </li>
            <li>
              Предоставлять Конфиденциальную информацию или ее часть каким-либо
              лицам или организациям, не относящимся к работникам и
              консультантам Получающей стороны, которым обоснованно необходимо
              иметь доступ к Конфиденциальной информации в целях,
              предусмотренных настоящим договором, и которые соглашаются
              обеспечивать сохранность Конфиденциальной информации как в том
              случае, если бы они были стороной по настоящему договору;
            </li>
            <li>
              Не допускать неправомерного использования Конфиденциальной
              информации, в том числе опубликованию в печати, интернете и в
              других источниках распространения информации.
            </li>
          </ul>
          <p>
            13.3. Обязательства по соблюдению конфиденциальности сохраняют свою
            силу и после истечения срока действия настоящего договора или
            досрочного его расторжения в течение последующих 20 (Двадцати) лет.
          </p>
          <p>
            13.4. Нарушившая условия конфиденциальности Сторона возмещает
            потерпевшей Стороне убытки в размере прямых потерь и упущенной
            выгоды.
          </p>
          <p>
            13.5. Не считается разглашением конфиденциальной информации, если
            она предоставляется уполномоченным государственным органам в
            случаях, прямо оговоренных в национальных законодательствах Сторон.
          </p>
          <h2 className="privacy__subtitle">14. Адрес и реквизиты МФО</h2>
          <p>Микрофинансовая организация ООО «PAYLATER»</p>
          <p>Адрес: город Ташкент, Мирабадский район, улица Афросиеб, 14</p>
          <p>ИНН: 309 776 769</p>
          <p>Номер контакт-центра:</p>
          <ul>
            <li>998 78 1137077</li>
            <li>998 78 1138488</li>
          </ul>
        </div>
      ) : (
        <div className="privacy__content">
          <h1 className="privacy__title">
            "PAYLATER" MMT MCHJNING "PAYLATER" ELEKTRON TIZIMI ORQALI ONLAYN
            MIKROQARZ BERISH TO'G'RISIDA OMMAVIY OFERTASI
          </h1>

          <h2 className="privacy__subtitle">1. ATAMA VA TA’RIFLAR</h2>

          <p>
            1.1. «Paylater» tizimi - dasturiy ta'minot va apparatlar to'plami
            bo'lib, u «Paylater» MMT MChJ (keyingi o'rinlarda MMT deb ataladi)
            mikromoliya tashkilotining xizmatlaridan masofadan turib foydalanish
            imkoniyatini beruvchi «Paylater» websaytini «www.paylater.uz»
            internet tarmog'ida o'z ichiga olgan.
          </p>

          <p>
            1.2. Mijoz – jismoniy shaxs, O'zbekiston Respublikasi fuqarosi,
            O'zbekiston Respublikasida doimiy istiqomat qiluvchi, Paylater
            tizimi orqali Mikroqarz olish niyatida bo’lgan.
          </p>

          <p>
            1.3. Qarz oluvchi — ushbu Ommaviy ofertada koʻrsatilgan shartlar
            boʻyicha tovarlarni sotib olish, ish va xizmatlar uchun toʻlov uchun
            Paylater tizimi orqali Mikroqarz olgan shaxs.
          </p>

          <p>
            1.4. Shaxsiy kredit shartlari – Mijozga Mikroqarz berishning aniq
            shartlari va shartlari (miqdori, muddati, foiz stavkasi va
            boshqalar), MMT tomonidan mijoz uchun hisoblangan chegaralar
            doirasida, mijoz tomonidan Mikroqarz olingandan keyin tasdiqlanishi
            mumkin bo'lgan moliyalashtirish miqdori.
          </p>

          <p>
            1.5. Kreditga ariza – mijoz tomonidan MTTga yuborilgan, mijoz
            tomonidan so'ralgan Mikroqarz haqida umumiy ma'lumotni o'z ichiga
            olgan, ushbu Ommaviy oferta shartlari bo'yicha Mikroqarz berish
            ehtimolini baholash maqsadida Paylater tizimida hosil qilingan
            elektron xabar.
          </p>

          <p>
            1.6. Mikroqarz – MMT tomonidan Qarz oluvchiga ushbu Ommaviy ofertada
            nazarda tutiladigan shartlar bo'yicha mablag'larni to'lov tizimidan
            foydalangan holda, kechiktirish, qaytarish, ta'minlash va to'lash
            shartlarida taqdim etiladigan mablag'lar.
          </p>

          <p>
            1.7. Savdo tashkiloti (ST) – Qarz oluvchidan mahsulot yoki xizmat
            uchun to'lov sifatida MMTlaridan to'lovlarni qabul qiluvchi savdo va
            xizmat ko'rsatish korxonasi.
          </p>
          <h2 className="privacy__subtitle">2. UMUMIY QOIDALAR</h2>

          <p>
            2.1. Ushbu Ommaviy oferta - MMT bilan Paylater tizimi orqali ushbu
            Ommaviy ofertaning umumiy taklif shartlari asosida Mikroqarz berish
            to'g'risida MMT bilan shartnoma tuzish uchun noma'lum miqdordagi
            mijozlarga yuborilgan rasmiy taklifdir.
          </p>

          <p>
            2.2. Mikroqarz shartnomasi O'zbekiston Respublikasi Fuqarolik
            kodeksining 367-moddasiga va 369-modda 2-qismiga muvofiq tuziladi va
            Mijoz ushbu Ommaviy ofertada ko'rsatilgan harakatlarni amalga
            oshirgan paytdan boshlab kuchga kiradi va ushbu Ommaviy oferta
            Mijozi tomonidan hech qanday istisnolarsiz yoki cheklovlarsiz
            so'zsiz qabul qilishini anglatadi.
          </p>

          <p>
            2.3. Ushbu Ommaviy oferta shartlariga rozi bo'lgan holda, Mijoz uni
            Paylater tizimi vositalaridan foydalangan holda yoki MMT tomonidan
            boshqa usulda onlayn tarzda qabul qilishi mumkin. Ushbu qabul MMT
            uchun mijozning Mikroqarz olish uchun arizasini dastlabki qarz
            oluvchi sifatida ko'rib chiqishi uchun asos bo'ladi. Agar MMT
            Mijozning Mikroqarz bo'yicha arizasini ma'qullasa, MMT individual
            kredit shartlarini mijozga yuboradi.
          </p>

          <p>
            2.4. Shaxsiy kredit shartlari Mijozning har bir Mikroqarz olishidan
            oldin alohida belgilanadi va Paylater tizimi orqali o'tkaziladi.
            Qarz oluvchi SMS-xabardan olingan kodni yoki MMT tomonidan taqdim
            etilgan har qanday boshqa usulda kiritish orqali Individual kredit
            shartlarini qabul qiladi va rozi bo'ladi. Qarz oluvchi tomonidan
            Ommaviy ofertaning ushbu shartlari qabul qilingan va Qarz oluvchi
            tomonidan Kreditning individual shartlari qabul qilingan taqdirda,
            ushbu Ommaviy oferta va Kreditning individual shartlarida nazarda
            tutilgan shartlar asosida Mikroqarz berish to'g'risidagi Shartnoma
            (keyingi o'rinlarda Shartnoma deb ataladi) tuzilgan hisoblanadi.
          </p>

          <p>
            2.5. Mijoz, mijozning kreditga layoqatliligi va boshqa ma'lumotlarni
            baholash amalga oshiriladigan MMTning skoring modeli tijorat siri
            bo'lib, maxfiy hisoblanishi rozilik bildiradi.
          </p>

          <p>
            2.6. Mijozni ushbu Ommaviy oferta (shu jumladan MMT tomonidan
            vaqti-vaqti bilan kiritilgan o'zgarishlar va/yoki qo'shimchalar)
            bilan tanishish maqsadida MMT ushbu hujjatlarni MMT veb-saytida
            e'lon qiladi. Bundan tashqari, MMT Mijozlarga ma'lumot olish va MMT
            dan kelib chiqishini aniqlashga imkon beradigan boshqa usullar bilan
            xabardor qilishi mumkin. Ushbu ma'lumotning nashr etilgan sanasi MMT
            veb-saytida birinchi joylashtirilgan sanasi hisoblanadi.
          </p>
          <h2 className="privacy__subtitle">3. SHARTNOMA MAVZUSI</h2>

          <p>
            3.1. MMT Qarz oluvchiga iste'mol maqsadlari uchun Mikroqarz taqdim
            etadi, shu jumladan tovarlarni sotib olish va xizmatlar (ishlar)
            uchun to'lovni Individual kredit shartlarida ko'rsatilgan miqdorda
            amalga oshirishni ta'minlaydi, Qarz oluvchi esa MMTdan olingan
            Mikroqarz summasini qaytarish va undan foydalanish uchun foizlarni
            ushbu Ommaviy oferta va Individual kredit shartlariga muvofiq
            to'lash majburiyatini oladi.
          </p>
          <h2 className="privacy__subtitle">4. MIKROQARZ BERISH TARTIBI</h2>

          <p>
            4.1. Mikroqarz Qarz oluvchiga ushbu Ommaviy oferta va Mikroqarzning
            Individual kredit shartlarida belgilangan shartlarda va tartibda
            naqd pulsiz shaklda Savdo tashkilotining joriy hisob raqamiga
            o'tkazish orqali Individual kredit shartlari aksept qilingan va
            Paylater tizimi orqali tovar jo‘natilishi tasdiqlangan kundan
            boshlab 15 (o‘n besh) bank kuni ichida beriladi.
          </p>

          <p>
            4.2. Mikroqarzni olish uchun Qarz oluvchi Paylater tizimining
            interfeysida ushbu Ommaviy ofertani ko’rib chiqishi va aksept
            qilishi (qabul qilishi) va Kredit arizasini yuborish orqali
            Mikroqarzni berish imkoniyatini so'rashi kerak.
          </p>

          <p>
            4.3. Mijoz ushbu Ommaviy oferta shartlari bo'yicha MMT tomonidan
            taqdim etiladigan mumkin bo'lgan moliyalashtirish miqdoridan
            oshmagan miqdorda Kreditga ariza topshirish huquqiga ega.
          </p>

          <p>
            4.4. Mijozning Kreditga murojaati Mikroqarzni qaytarish oyining
            miqdori, muddati, foiz stavkasi va sanasini o'z ichiga oladi va
            mijoz tomonidan qabul qilingan ushbu Ommaviy ofertaning ajralmas
            qismi bo'ladi.
          </p>

          <p>
            4.5. Kredit arizasi ko'rib chiqilgandan so'ng, MMT Mijozga Paylater
            tizimining interfeysida uning tasdiqlanishi to’g’risida, taqdim
            etilgan summa miqdori, muddat, Mikroqarzni qaytarish jadvalini o’z
            ichiga Individual kredit shartlarini yuborish, yoki Mikroqarzni
            berishning iloji yo’qligi to’g’risida xabar beradi.
          </p>

          <p>
            4.6. Ushbu Ommaviy ofertani va Individual kredit shartlarini aksept
            qilgan holda, Mijoz MMTga Mijozning shaxsiy ma'lumotlarini ko'rib
            chiqish, berish va berish jarayonlari bilan bog'liq maqsadlarda
            "Shaxsiy ma'lumotlar to'g’risida" gi O'zbekiston Respublikasi Qonuni
            va nobank kredit tashkilotlari to’g’risidagi qonunchilikka
            talablariga muvofiq talab qilinadigan darajada rasmiy manbalardan va
            boshqa manbalardan talablarga muvofiq cheksiz ko'p marta so’rash,
            olish, ishlov berish va uzatishga roziligini bildiradi va MMTga
            shunday vakolat beradi.
          </p>

          <p>
            4.7. MMT tomonidan tasdiqlangan Mijozni moliyalashtirish miqdori MMT
            uchun Mijozning Kreditga layoqatliligini baholash orqali Mijoz
            to'g'risidagi va/yoki so’ralgan ma'lumotlar asosida aniqlanadi.
            Mijozning Kreditga layoqatliligini baholash metodikasi MMT ning
            savdo siri bo'lib, maxfiy deb hisoblanadi.
          </p>

          <p>
            4.8. Kredit arizasini topshirish va Individual kredit shartlarini
            aksept qilish Mijozning Individual kredit shartlarida ko'rsatilgan
            Mikroqarzni olishga roziligini tasdiqlaydi.
          </p>

          <p>
            4.9. MMT tomonidan Mikroqarz berish majburiyati Mikroqarz berilgan
            kundan boshlab bajarilgan hisoblanadi.
          </p>
          <h2 className="privacy__subtitle">
            5. MIKROQARZNI QAYTARISH TARTIBI
          </h2>

          <p>
            5.1. Mikroqarz bo'yicha asosiy qarzni to’lash (qaytarish) Qarz
            oluvchi tomonidan Mikroqarzning valyutasida Individual kredit
            shartlariga muvofiq amalga oshiriladi.
          </p>

          <p>
            5.2. Qarz oluvchi Paylater tizimida ko'rsatilgan To'lov jadvalida
            ko'rsatilgan shartlarga muvofiq olingan Mikroqarzni to’lashni o'z
            zimmasiga oladi.
          </p>

          <p>
            5.3. Qarz oluvchining Mikroqarzini to'lash uchun tushgan mablag'lar
            Mikroqarz bo'yicha asosiy qarzni to'lashga yo'naltiriladi.
          </p>

          <p>
            5.4. Shartnoma bo'yicha qarzni qisman muddatidan oldin to'lash Qarz
            oluvchining Individual shartlari bo'yicha to'lovlarining miqdori,
            hajmi va chastotasini (muddatlarini) aniqlash tartibini
            o'zgartirishga olib kelmaydi. Qarz oluvchi tomonidan To'lovlar
            jadvalida belgilanganidan ortiq to'langan summalar asosiy qarzni
            muddatidan oldin to'lash uchun sarflanadi.
          </p>

          <p>
            5.5. Muddatli qarz (muddati tugamagan qarz/Mikroqarzni muddatidan
            oldin to'lash) Qarz oluvchining ko'rsatmalariga muvofiq to'lanadi.
          </p>

          <p>
            5.6. Mikroqarzni to'lash ushbu Ommaviy ofertada ko'rsatilgan MMT
            hisobvarag'iga pul o'tkazish yo'li bilan amalga oshiriladi.
            Mikroqarzni to'lash sanasi ko'rsatilgan hisob raqamiga mablag'
            tushgan kun hisoblanadi.
          </p>

          <p>
            5.7. Muddati o'tgan qarz paydo bo'lganda, MMT oldidagi
            majburiyatlarini bajarish uchun Mijoz Ommaviy ofertani qabul qilib,
            MMTga Mijozning barcha hisobvaraqlaridan (ya'ni bank plastik
            kartalaridan) mablag'larni so’ramagan holda (aktsepsiz) hisobdan
            yechib olish uchun rozilik beradi.
          </p>
          <h2 className="privacy__subtitle">
            6. SHAXSIY MA'LUMOTLARGA ISHLOV BERISH
          </h2>

          <p>
            6.1. Shartnoma tuzish, shuningdek MMTga Kredit arizasini yuborish
            orqali Mijoz / Qarz oluvchi MMTga Mijoz tomonidan taqdim etilgan
            shaxsiy ma'lumotlarni to'plash, yozib olish, tizimlashtirish,
            saqlash, aniqlashtirish (yangilash, o'zgartirish), chiqarib olish,
            foydalanish, uzatish (kirish huquqini berish, shu jumladan uchinchi
            shaxslarga shaxsiy ma'lumotlarni qayta ishlashga topshirishda),
            egasizlantirish, blokirovka qilish, o'chirish, mijoz/qarz
            oluvchining shaxsiy ma'lumotlarini yo'q qilish avtomatlashtirish
            vositalaridan foydalangan holda va/yoki foydalanmasdan qog'oz
            va/yoki elektron ommaviy axborot vositalarida cheksiz ko'p marta
            qayta ishlash huquqini (roziligini) beradi.
          </p>

          <p>
            6.2. Ushbu Shartnoma maqsadlari uchun Mijoz/Qarz oluvchining shaxsiy
            ma'lumotlari MMT tomonidan Mijoz/Qarz oluvchi tomonidan yoki uning
            roziligi bilan Mijoz/Qarz oluvchiga to'g'ridan-to'g'ri yoki
            bilvosita identifikatsiya qilingan yoki uning yordami bilan
            aniqlangan ma'lumotlarni anglatadi, shu jumladan quyidagi
            ma'lumotlar: familiyasi, ismi, otasining ismi; tug'ilgan sana, oy va
            yil; jinsi; aloqa ma'lumotlari (telefon raqamlari, elektron pochta
            manzillar); shaxsini tasdiqlovchi hujjat ma’lumotlari; yashash joyi
            va/yoki vaqtinchalik yashash joyi to'g'risidagi ma'lumotlar, ta'lim
            to'g'risidagi ma'lumotlar, oilaviy ahvoli, bolalar soni, bandligi va
            faoliyat sohasi, ish beruvchi to'g'risidagi ma'lumotlar, o'rtacha
            oylik daromad, oylik xarajatlar va boshqalar.
          </p>

          <p>
            6.3. Mijozning yuqorida ko'rsatilgan shaxsiy ma'lumotlarini qayta
            ishlashga quyidagi maqsadlar uchun ruxsat beriladi: MMT tomonidan
            Mijoz bilan Shartnoma tuzish imkoniyati, uni tuzish to'g'risida
            ijobiy yoki salbiy qaror MMT tomonidan qabul qilinishi mumkin, shu
            jumladan Mijoz/Qarz oluvchining shaxsiy ma'lumotlarini faqat
            avtomatlashtirilgan tarzda qayta ishlash orqali; Mijoz/Qarz oluvchi
            tomonidan taqdim etilgan ma'lumotlarning to'g'riligini tekshirish;
            Kelishuvni bajarish va tugatish; Shartnoma bo'yicha qarzlarni
            qaytarib olish (qaytarish, yig'ish); Mijoz/Qarz oluvchining to'lov
            qobiliyatini baholash; qidirish va uning ish joyini tekshirish,
            haqiqiy yashash joyi manzili, telefon raqami va Mijoz/Qarz
            oluvchidan olingan boshqa ma'lumotlar; Mijoz/Qarz oluvchining MMT
            mahsulotlariga bo'lgan qiziqishini aniqlash; Mijoz/Qarz oluvchini
            marketing segmentlariga tayinlash; MMTning Mijozga yoki Qarz
            oluvchiga boshqa xizmatlari va mahsulotlarini taqdim etish (shu
            bilan birga MMT tomonidan ko'rsatiladigan boshqa xizmatlarni taqdim
            etish bilan bog'liq boshqa shartnomalar tuzish imkoniyatini ko'rib
            chiqish).
          </p>

          <p>
            6.4. Shartnomani tuzish orqali Mijoz MMTga O'zbekiston
            Respublikasining "Kredit axboroti almashinuvi to'g'risida"gi
            Qonuniga muvofiq shartnomaning amal qilish muddati davomida shaxsiy
            mahsulot takliflaridan maxsus shartlarda olish uchun kredit tarixi
            byurosida o'zining kredit tarixi to'g'risidagi ma'lumotlarni so'rash
            uchun cheksiz marta istalgan vaqtda qaytarib bo'lmaydigan va to'liq
            rozilik beradi.
          </p>
          <h2 className="privacy__subtitle">
            7. TOMONLARNING HUQUQ VA MAJBURIYATLARI
          </h2>

          <p>Qarz oluvchi quyidagilarga haqli:</p>

          <p>
            7.1. Mikroqarzni ushbu shartnomada belgilangan muddatlardan oldin
            istalgan vaqtda, jarimalar qo’llanilmagan holda to'lash huquqi.
          </p>

          <p>
            7.2. Mikroqarz olishdan pul mablag'lari kiritilishidan oldin bepul
            voz kechish.
          </p>

          <p>
            7.3. Shartnoma amal qilish muddati davomida bir ish kuni davomida
            oyiga bir marta yozma ravishda quyidagi ma'lumotlarni bepul olish:
          </p>

          <ul>
            <li>
              Mikroqarz bo'yicha to'langan pul mablag'lari summasi
              to'g'risidagi;
            </li>
            <li>Asosiy qarz qoldig'i to'g'risidagi;</li>
            <li>
              Keyingi to'lovlarning miqdori, tarkibi va muddatlari to'g'risidagi
              (to'lovlar jadvali);
            </li>
            <li>Muddati o'tgan qarz miqdori va tarkibi to'g'risidagi;</li>
            <li>
              Mikroqarz bo'yicha qarzni to'lash uchun tushgan mablag'larning
              yo'nalishi bo'yicha to'lov.
            </li>
          </ul>

          <p>
            Mijoz ushbu turdagi xabarlarni elektron shaklda Paylater tizimi
            yordamida amalga oshirish shartini qabul qiladi, ular qog'ozdagi
            hujjatga tenglashtiriladi va u bilan bir xil yuridik kuchga ega
            bo’ladi.
          </p>

          <p>
            7.4. MMTga yozma ravishda xabar berish orqali Mikroqarz berish
            to'g'risida shartnoma tuzilgan kundan boshlab ikki hafta ichida
            foydalanilmagan Mikroqarz summasidan voz kechish huquqi.
          </p>

          <p>Qarz oluvchi quyidagilarga majbur:</p>

          <p>
            7.5. Qarzni va Shartnomada nazarda tutilgan barcha to'lovlarni
            Shartnomada belgilangan muddatlarda to'lash. Qarz oluvchi Tovarni
            Savdo tashkilotiga qaytarganda, Mikroqarz bo'yicha qarzni to'lash
            uchun Tovarning qiymati MFO hisobvarag'iga qaytariladi. Shu bilan
            birga, Qarz oluvchining hisobvarag'iga/kartasiga Savdo tashkiloti
            tomonidan qaytarilishi natijasida tushgan mablag'lar mustaqil Qarz
            oluvchi tomonidan Mikroqarz bo'yicha qarzni to'lash uchun yuborilgan
            bo'lishi kerak.
          </p>

          <p>
            7.6. MMT talabiga binoan, zarur bo'lganda, MMTdan tegishli so'rov
            kelib tushgan kundan boshlab 3 ish kuni ichida MMTni moliyaviy va
            mulk holatini tasdiqlovchi har qanday hujjatlar bilan ta'minlash;
          </p>

          <p>
            7.7. To'liq ism-sharifi, yashash joyi, ish joyi, shaxsiy
            ma'lumotlar, shaxsiy, biografik ma'lumotlar yoki boshqa ma'lumotlar
            o'zgartirilgan taqdirda, MMTga bunday o'zgarishlar sodir bo'lgan
            kundan boshlab 1 (bir) kun ichida xabar berish;
          </p>

          <p>
            7.8. Moliyaviy holatning yomonlashuviga va MMT oldidagi
            majburiyatlarning bajarilmasligi va/yoki noto'g'ri bajarilishi
            xavfiga olib kelishi mumkin bo'lgan majburiyat va choralarni o'z
            zimmalariga olmaslik;
          </p>

          <p>
            7.9. MMT, uning xodimlari va vorislari, outsourcing kompaniyalari
            tomonidan MMT, uning xodimlari va vorislari tomonidan taqdim etilgan
            ma'lumotlarni, shuningdek Mikroqarz olish uchun Mijoz tomonidan
            taqdim etilgan ma'lumotlar va Kredit olish uchun taqdim etilgan
            hujjatlar, shu jumladan ularning yashash joyi, ish joyi tashrif
            buyurish orqali tekshirish imkoniyatini taqdim etish va boshqalar;
          </p>

          <p>
            7.10. MMTning talabiga ko'ra, MMT tomonidan amalga oshirilgan barcha
            xarajatlar va zararlar uchun, shu jumladan ushbu Shartnoma bo'yicha
            taqdim etilgan Mikroqarz (asosiy va boshqa to'lovlar) bo'yicha
            Qarzni majburiy va/yoki muddatidan oldin undirish bo'yicha
            choratadbirlar qabul qilinganligi munosabati bilan uni qaytarish;
          </p>

          <p>
            7.11. Mijoz MMT roziligisiz Mikroqarz bo'yicha o'z huquq va
            majburiyatlarining barchasini yoki bir qismini boshqa shaxsga
            topshirishga haqli emas.
          </p>
          <p>MMT quyidagilarga haqli:</p>

          <p>
            7.12. Mikroqarz berish jarayonida MMT Mijoz/Qarz oluvchining
            moliyaviy holatini tekshirish huquqiga ega. Bunday tekshiruvlarning
            davriyligi MMT tomonidan belgilanadi;
          </p>

          <p>
            7.13. Ushbu Ommaviy ofertaning 7.14-bandda nazarda tutilgan holatlar
            yuzaga kelgan taqdirda MMT quyidagi huquqlarga ega bo’ladi:
          </p>

          <ul>
            <li>
              Shartnoma bo'yicha Mikroqarzni bir tomonlama tartibda (agar
              Mikroqarz qisman berilgan bo'lsa) muddatidan oldin bekor qilish,
              bu haqda Qarz oluvchini amaldagi qonun hujjatlarida belgilangan
              muddatlarda xabardor qilish va/yoki Mikroqarzni muddatidan oldin
              undirish uchun taqdim etish (Mikroqarz bo'yicha qarzni muddatidan
              oldin to'liq to'lashni talab qilish). Yozma xabarnoma yuborilgan
              sana Qarz oluvchiga topshirilgan sana yoki pochta jo'natilgan sana
              hisoblanadi;
            </li>
            <li>
              Sud organlari orqali, shu jumladan sud buyrug'ini olish orqali ham
              muddati o'tgan, ham to'liq Mikroqarz qarzini undirish. Yozma
              xabarnoma yuborilgan sana Qarz oluvchiga topshirilgan sana yoki
              pochta jo'natilgan sana hisoblanadi;
            </li>
            <li>
              Notariat organlari orqali notariusning ijro xatini olish orqali
              Mikroqarz bo'yicha muddati o'tgan va to'liq Qarzlarni undirish;
            </li>
            <li>
              O'zining yagona mutlaq xohishiga ko'ra, Mikroqarz bo'yicha
              to'lovlarni amalga oshirish bilan bog'liq bo'lmagan Shartnoma
              bo'yicha majburiyatlarni bajarish bo'yicha sud protseduralarini
              boshlash;
            </li>
            <li>
              Shartnoma bo'yicha yangi summalar va/yoki yangi Mikroqarzlar
              berishni to'xtatish;
            </li>
          </ul>

          <p>
            7.14. Quyidagi holatlarning boshlanishi MMTga ushbu Ommaviy taklif
            7.13-bandda nazarda tutilgan harakatlarni amalga oshirish (huquqidan
            foydalanish) huquqini beradi:
          </p>

          <ul>
            <li>
              MMT xodimlari tomonidan Mikroqarzdan maqsadli foydalanishni
              tekshirish uchun Mikroqarzdan maqsaddan tashqari foydalanish
              va/yoki imkoniyat va/yoki hujjatlarni taqdim etmaslik;
            </li>
            <li>
              Qarz oluvchi Mikroqarz bo'yicha har qanday qarzni (asosiy qarz,
              jarimalar, komissiyalar va boshqa to'lovlar) to'lash majburiyatini
              bajarmaganligi yoki MMT oldidagi boshqa majburiyat, ushbu
              Mikroqarz va/yoki ilgari olingan Mikroqarzlar (Mikroqarzlar)
              bo'yicha muddati o'tgan qarzdorlik mavjudligi;
            </li>
            <li>
              Qarz oluvchi tomonidan Shartnoma bo'yicha, shuningdek MMT bilan
              tuzilgan boshqa Shartnomalar bo'yicha o'z zimmasiga olingan
              majburiyatlarning buzilishi va/yoki bajarilmasligi va/yoki lozim
              darajada bajarilmasligi;
            </li>
            <li>
              Qarz oluvchining moliyaviy holatining yomonlashishi, shu jumladan,
              daromad manbai yo'qligi;
            </li>
            <li>
              Qarz oluvchi tomonidan noto'g'ri yoki yolg'on ma'lumotlarni taqdim
              etish yoki MMT tomonidan so'ralgan ma'lumotlarni taqdim etishdan
              bosh tortish, shu jumladan kreditni, Qarz oluvchining moliyaviy
              holatini monitoring qilish uchun;
            </li>
            <li>
              Qarz oluvchining boshqa kreditorlar oldidagi qarzini to'lov
              muddati tugagunga qadar yoki boshqa asosda e'lon qilish uning
              to'lov muddati tugagunga qadar to'lov qilinishi lozimligi;
            </li>
            <li>
              Qarz oluvchining mol-mulkini undirish yoki uchinchi shaxslar
              tomonidan hibsga olinishi; Mikroqarz Qarzining ta'minlanmagan
              qismini shakllanishi;
            </li>
            <li>
              MMT fikriga ko'ra Mikroqarz bo'yicha to'lov majburiyatlarining
              bajarilishiga jiddiy ta'sir ko'rsatadigan va/yoki Mikroqarzni
              qaytarmaslik xavfini oshiradigan har qanday omillarning paydo
              bo'lishiga jiddiy ta'sir ko'rsatadigan hodisalar ro'y berishi;
            </li>
            <li>
              Agar qarz oluvchiga nisbatan jinoiy ish yoki sud ishi
              qo'zg'atilgan bo'lsa yoki Qarz oluvchining mol-mulki qarzni
              qoplashni ta'minlash uchun hibsga olingan bo'lsa yoki Qarz
              oluvchining pul mablag'lari yoki boshqa mol-mulki bilan
              operatsiyalar muzlatilgan va/yoki to'xtatilgan bo'lsa;
            </li>
            <li>
              Shartnomani tuzish va undan foydalanishning maqsadi jinoiy
              faoliyatdan olingan daromadlarni legallashtirish, terrorizmni
              moliyalashtirish va ommaviy qirg'in qurollarini tarqatishni
              moliyalashtirishdan iborat degan shubhalar mavjudligi;
            </li>
            <li>
              Qarz oluvchining mol-mulkini to'lash va/yoki undirish va/yoki Qarz
              oluvchining shartnoma bo'yicha majburiyatlarini bajarishini xavf
              ostiga qo'yadigan uchinchi shaxslar tomonidan hibsga olish
              to'g'risida da'vo qo'zg'atilganda.
            </li>
          </ul>

          <p>
            7.15. MMT o'z xohishiga ko'ra, ushbu Ommaviy ofertada ko'rsatilgan
            huquq/talablarning birortasini qo'llashi yoki qo'llay olmasligi
            mumkin. Ushbu huquqlarni/talablarni qo'llamaslik yoki qisman
            qo'llash ushbu huquqlardan/talablardan voz kechishni tashkil
            qilmaydi va ular Shartnoma muddati davomida istalgan vaqtda
            qo'llanilishi mumkin.
          </p>

          <p>
            7.16. MMT Mijoz bilan bog'lanib, unga aloqa yo'li bilan va kredit
            arizasida ko'rsatilgan manzillarga (telefon raqamlariga) hamda Mijoz
            tomonidan Mikroqarzni olganlik uchun MMTga taqdim etilgan boshqa
            hujjatlarga, shuningdek Mijozdan olingan aloqa ma'lumotlariga, shu
            jumladan telefon orqali Shartnoma bo'yicha muddati o'tgan qarzlar
            mavjudligi va majburiyatlarning bajarilmaganligi to'g'risida
            xabarnoma va bildirishnomalar yuborish huquqiga ega. Telefon
            raqamiga, doimiy ro'yxatdan o'tish/yashash joyi manzili bo'yicha
            pochta xizmati orqali, elektron pochta orqali yoki boshqa aloqa
            vositalari orqali, shuningdek, doimiy ro'yxatdan o'tish/haqiqiy
            yashash joyi/ish joyining ko'rsatilgan manzili bo'yicha Mijozga
            tashrif buyurish orqali SMS-xabarnoma yuborish.
          </p>

          <p>
            7.17. MMT Shartnoma bo'yicha huquq va majburiyatlarining hammasini
            yoki bir qismini Qarz oluvchining roziligisiz boshqa shaxsga
            topshirishga haqlidir.
          </p>

          <p>
            7.18. MMT Mijoz tomonidan muddati o'tgan Qarz paydo bo'lganda, MMT
            oldidagi majburiyatlarni bajarish maqsadida Qarzni to'lash uchun har
            qanday hisobvaraqdan (bank plastik kartasidan) muddati o'tgan Qarz
            miqdorini ruxsatsiz yechib olish huquqiga ega.
          </p>
          <p>MMT o'z zimmasiga oladi:</p>

          <p>
            7.19. MMT Qarz oluvchiga Mikroqarzdan limit doirasida, Ommaviy
            oferta va Individual shartlarida ko'rsatilgan shartlar doirasida
            foydalanish imkoniyatini taqdim etishga haqli.
          </p>

          <p>
            7.20. Qarz bo'yicha Qarzni undirish uchun Qarz oluvchiga Qarzni
            to'lash zarurligi va muddati o'tgan qarz paydo bo'lgan kundan
            boshlab 10 (o’n) kalendar kun ichida Qarz majburiyatlarini
            bajarmaslik oqibatlari to'g'risida quyidagi aloqa usullaridan biri
            yordamida xabar berish: Mijoz tomonidan taqdim etilgan mobil telefon
            raqamiga SMS/PUSH xabarnomalari orqali, shuningdek, Qarz oluvchining
            Shartnomada ko‘rsatilgan manziliga muddati o‘tgan qarzni to‘lash
            zarurligi to‘g‘risida yozma so‘rov yuborish orqali. Xabarnomani
            qo'lda yuborish va bu haqda telefon orqali og'zaki eslatish mahalliy
            vaqt bilan soat 20:00 dan 8:00 gacha amalga oshirilmaydi.
          </p>

          <p>
            7.21. Agar Shartnoma bo'yicha majburiyatlar MMTga Mijozning tegishli
            so'rovi kelib tushgan kundan boshlab bir ish kuni ichida to'liq
            bajarilgan bo'lsa, Mijoz tomonidan Shartnoma bo'yicha
            majburiyatlarning to'liq bajarilishini tasdiqlovchi hujjatni
            Paylater tizimi orqali yoki Mijozning iltimosiga binoan yozma
            ravishda taqdim etilishi kerak.
          </p>

          <p>
            7.22. Qarz oluvchining tegishli so'rovi MMTda ro'yxatdan o'tgan
            kundan boshlab o’n ish kuni ichida Mijozga Mikroqarz berilganligini
            tasdiqlovchi hujjatni taqdim etish kerak.
          </p>
          <h2 className="privacy__subtitle">8. TOMONLARNING JAVOBGARLIGI</h2>

          <p>
            8.1. Tomonlar Shartnoma va amaldagi qonunchilik shartlariga muvofiq
            Shartnoma bo'yicha o'z majburiyatlarini bajarmaganlik yoki lozim
            darajada bajarmaganliklari uchun javobgar bo'ladilar.
          </p>

          <p>
            8.2. Tomonlar Shartnoma bo'yicha o'z majburiyatlarini to'liq yoki
            qisman bajarmaganligi uchun javobgarlikdan ozod qilinadi, agar
            bajarmaslik fors-major holatlari, ya'ni ushbu sharoitlarda
            favqulodda va muqarrar holatlar natijasida yuzaga kelsa. Fors-major
            holatlarining ta'siri tomonlar vakolatli organlarning hujjatlari
            bilan tasdiqlanishi kerak. Bunday holatlarga, shu jumladan, harbiy
            harakatlar, ommaviy tartibsizliklar, tabiiy ofatlar, harbiy-siyosiy
            vaziyatning o'zgarishi, elektr energiyasining uzilishi, ish
            tashlashlar, davlat hokimiyati va mahalliy o'zini o'zi boshqarish
            organlarining qarorlari, ushbu ommaviy taklifda nazarda tutilgan
            majburiyatlarni bajarishni imkonsiz qiladigan qonunlar va boshqa
            normativ hujjatlar chiqarilishi kiradi.
          </p>

          <p>
            8.3. Shu bilan birga, Tomonlar koronavirus pandemiyasi (COVID-19) va
            (yoki) boshqa epidemiyalar yoki kasalliklarning tarqalishi,
            shuningdek, pandemiya bilan bog'liq holda kiritilgan cheklov
            choralari (shu jumladan O'zbekiston Respublikasida karantin e'lon
            qilinishi) ushbu Shartnoma bo'yicha "Fors-major vaziyati" mazkur
            shartnoma bo'yicha tomonlar O'zbekiston Respublikasi Fuqarolik
            Kodeksining 333-moddasining 3-qismiga muvofiq uning dispozitivligini
            hisobga olgan holda forsmajor holatlari to'g'risidagi qoidalarni
            qo'llashni istisno qiladilar. Shartnomaning ushbu bandining amal
            qilishi, hatto Davlat organlari tomonidan tomonlar tomonidan oqilona
            choralar bilan oldindan ko'ra olmaydigan va/yoki oldini ololmaydigan
            shartnoma bo'yicha majburiyatlarning to'g'ri bajarilishiga
            cheklovlar qo'yadigan harakatlar yoki qarorlar qabul qilingan
            taqdirda ham qo'llaniladi.
          </p>

          <p>
            8.4. Mijoz Mikroqarz va boshqa to'lovlarni o'z vaqtida va to'liq
            qaytarilishi, shuningdek, Mijozning majburiyatlarini bajarmaganligi
            yoki lozim darajada bajarmaganligi sababli Qarzni undirish bo'yicha
            sud xarajatlarini qoplash uchun barcha mol-mulki bilan MMT oldida
            javobgardir.
          </p>

          <p>
            8.5. Shartnoma shartlariga ko'ra Mikroqarz summasi to'liq yoki
            qisman o'z vaqtida kreditlashtirilmagan taqdirda, Qarz oluvchi MFO
            dan muddati o'tgan majburiyat summasining 0,01 foizi miqdorida penya
            undirishga haqli, ammo muddati o'tgan majburiyat summasining 10% dan
            ko'proq emas.
          </p>

          <p>
            8.6. MMT o'z nazorati doirasidan tashqarida ziddiyatli va bahsli
            vaziyatlarning paydo bo'lishi uchun javobgar emas.
          </p>

          <p>
            8.7. MMT texnik nosozliklar (elektr ta'minoti va aloqa tarmoqlari
            uzilishi/shikastlanishi, to'lov tizimlarining ishlashidagi texnik
            nosozliklar), Mijoz hisob raqamiga pul o'tkazish uchun tafsilotlarni
            noto'g'ri/to'liq ko'rsatmagan taqdirda, Ommaviy taklifning ushbu
            shartlarini bajarmaganligi yoki o'z vaqtida bajarmaganligi uchun
            javobgar bo'lmaydi.
          </p>

          <p>
            8.8. MMT foizlarni, komissiyalarni, jarimalarni yiliga Qarz olish
            miqdorining yarmidan ko'p bo'lmagan miqdorda hisoblash va undirish
            huquqiga ega.
          </p>
          <h2 className="privacy__subtitle">
            9. NIZOLARNI HAL QILISH VA MUROJATLARNI QAYTA ISHLASH TARTIBI
          </h2>

          <p>
            9.1. Tomonlar tomonidan mazkur Shartnomani bajarish jarayonida
            yuzaga keladigan barcha nizolar tomonlar tomonidan oʻzaro maqbul
            yechimga erishish maqsadida dastlabki koʻrib chiqiladi. Tomonlar
            kelishuvga erisha olmagan taqdirda, ushbu Shartnomadan kelib
            chiqishi yoki kelib chiqishi mumkin bo'lgan yoki u bilan bog'liq
            bo'lgan barcha nizolar, kelishmovchiliklar, talab yoki da'volar, shu
            jumladan uning xulosasi, o'zgartirish, ijro etish, buzish,
            to'xtatish, haqiqiy emaslik, xulosa chiqarmaslik yoki xavfsizlikni
            tiklash (butunlay va/yoki qisman) bilan bog'liq bo'lganlar hal
            etiladi:
          </p>

          <ul>
            <li>fuqarolik ishlari bo'yicha Mirobod tumanlararo sudida;</li>
            <li>
              yoki "CONSILIO" Mas'uliyati cheklangan jamiyati huzuridagi
              hakamlik sudida, uning reglamentiga muvofiq, yakka tartibdagi
              hakamlik sudyasi tomonidan. Hakamlik sudining qarori tomonlar
              uchun yakuniy va majburiydir;
            </li>
            <li>
              yoki suddan tashqari / sudgacha, shu jumladan notarial ijro
              yozuvini olish orqali. Notarial ijro yozuvini olish orqali qarzni
              undirish holatida Qarz oluvchi notarial ijro yozuvining
              haqiqiyligini shubhasiz tarzda tan oladi. Daʼvogar yuqoridagi
              sudlardan birida daʼvo arizasini qoʻyishni tanlash yoki nizoni
              sud/suddan oldin hal qilish huquqiga ega.
            </li>
          </ul>

          <p>
            9.2. MMT muddati o'tgan qarzdorlikni qaytarish to'g'risida sud
            organlariga murojaat qilishdan 10 kun oldin so'rov yuborish
            majburiyatini oladi. Talabnomada ko'rsatilgan vaqt chegarasida Qarz
            oluvchi tomonidan talab bajarilmagan yoki noto'g'ri bajarilgan
            taqdirda, MMT sud organlariga da'vo arizasi berish huquqiga ega
            bo'ladi.
          </p>

          <p>
            9.3. MMT Mikroqarz bo'yicha to'lanmagan mablag'larni qaytarishni,
            barcha hisoblangan foizlarni va boshqa qo'shimcha talablarni
            to'lashni, shuningdek Mijoz tomonidan MFO tomonidan yetkazilgan
            barcha zararni qoplashni talab qilishga haqlidir.
          </p>

          <p>
            9.4. Jarima to'lash Qarz oluvchini o'z majburiyatlarini bajarishdan
            yoki qoidabuzarliklarni bartaraf etishdan ozod qilmaydi.
          </p>

          <p>
            9.5. Ushbu Ommaviy ofertada nazarda tutilmagan Qarz oluvchi va MMT
            javobgarligi choralari O'zbekiston Respublikasi qonun hujjatlariga
            muvofiq qo'llaniladi.
          </p>
          <h2 className="privacy__subtitle">
            10. SHARTNOMANI O’ZGARTIRISH VA BEKOR QILISH TARTIBI
          </h2>

          <p>
            10.1. Shartnoma istalgan vaqtda Mijozning tashabbusi bilan bekor
            qilinishi mumkin, agar MMT bilan yakuniy hisob-kitob va Shartnomani
            bekor qilish to'g'risida ariza taqdim etilganda qarzni to'liq
            to'lash sharti bilan.
          </p>

          <p>
            10.2. Shartnoma MMT tashabbusi bilan Mijoz Shartnoma bo'yicha
            majburiyatlarni bajarmagan taqdirda bir tomonlama suddan tashqari
            tartibda bekor qilinishi mumkin, bunda shartnoma MMT Qarz oluvchiga
            bunday bekor qilish to'g'risida xabar bergan kundan boshlab 3 (uch)
            kundan keyin bekor qilingan deb hisoblanadi.
          </p>

          <p>
            10.3. Shartnomani bekor qilish Qarz oluvchining MMT oldidagi
            Shartnoma bo'yicha Qarzni, shu jumladan Shartnoma davrida yuzaga
            kelgan MMT komissiyalarini to'lash bo'yicha Qarzni to'lash
            majburiyatini bekor qilishga olib kelmaydi.
          </p>
          <h2 className="privacy__subtitle">11. SHARTNOMA MUDDATI</h2>
          <p>
            11.1. Shartnoma mijozning shaxsiy kredit shartlarini qabul qilgan
            paytdan boshlab kuchga kiradi va Qarz oluvchi Mikroqarz bo'yicha o'z
            majburiyatlarini to'liq bajarganidan keyin tugatiladi.
          </p>

          <h2 className="privacy__subtitle">12. YAKUNIY QOIDALAR</h2>
          <p>
            12.1. Ushbu Ommaviy ofertada ko'zda tutilmagan shartlar O'zbekiston
            Respublikasining amaldagi qonunchiligiga muvofiq tartibga solinadi.
          </p>
          <p>
            12.2. Mijoz/ Qarz oluvchi MMT reklama materiallari MMT xizmatlarini
            ommalashtirish bilan bog'liq barcha aloqa vositalaridan foydalangan
            holda to'g'ridanto'g'ri aloqa o'rnatish orqali lekin ular bilan
            cheklanmaydi: pochta, SMS-xabar, ovozli xabar, elektron pochta va
            boshqalar, olishga rozilik bildiradi.
          </p>
          <p>
            12.3. Nizolar yuzaga kelgan taqdirda, bank hisobotlari ushbu Ommaviy
            oferta/Shartnoma bo'yicha ikkala tomonning majburiyatlarining asosiy
            dalili bo'ladi.
          </p>
          <p>
            12.4. Qarz oluvchi vafot etgan taqdirda uning barcha huquq va
            majburiyatlari O'zbekiston Respublikasi qonun hujjatlarida
            belgilangan tartibda uning vorislariga o'tadi.
          </p>
          <p>
            12.5. Ommaviy oferta hozirgi paytdan boshlab va Uning "Paylater"
            tizimida/MMT veb-saytida e'lon qilingan paytdan boshlab va uning
            amal qilish muddati davomida haqiqiy deb hisoblanadi.
          </p>

          <h2 className="privacy__subtitle">13. MAXFIYLIK</h2>
          <p>
            13.1. Tomonlar axborotning maxfiyligini ta’minlash majburiyatini
            oladi, shu jumladan bank va tijorat sirlari to'g'risidagi qonun
            hujjatlariga muvofiq bo’lgan holda.
          </p>
          <p>
            13.2. Tomonlar ushbu Shartnoma bo'yicha o'z majburiyatlarini
            bajarish uchun har bir tomon uchun zarur bo'lgan ma'lumotlarni
            almashadilar. Ushbu Shartnoma bo'yicha majburiyatlarning bajarilishi
            bilan bog'liq barcha yozma yoki og'zaki ma'lumotlar, bir tomon
            tomonidan boshqa tomonga taqdim etilgan, maxfiy hisoblanadi, hisobga
            olinadi va shu bilan maxfiy ma'lumotlar sifatida belgilanadi. Maxfiy
            ma'lumotlar, shu jumladan ushbu shartnomada ko'rsatilgan barcha
            ma'lumotlarni o'z ichiga oladi. Maxfiy ma'lumotlar unga ruxsatsiz
            kirishdan himoya qilinadi, uning yaxlitligini, xavfsizligini va o'z
            vaqtida taqdim etilishini ta'minlaydi. Ushbu Shartnomaga muvofiq
            maxfiy ma'lumotlarni olgan tomon ("qabul qiluvchi tomon") bunday
            ma'lumotlarni taqdim etuvchi tomonning yozma roziligini olmasdan
            ("uzatuvchi tomon"):
          </p>
          <ul>
            <li>
              ushbu Shartnomada nazarda tutilmagan maqsadlarda maxfiy
              ma'lumotlarning bir qismidan foydalanmaydi;
            </li>
            <li>
              ushbu Shartnomada nazarda tutilgan maqsadlar uchun maxfiy
              ma'lumotlarga ega bo'lishi kerak bo'lgan va maxfiy ma'lumotlarning
              xavfsizligini ta'minlashga rozi bo'lgan, qabul qiluvchi tomonning
              ishchilari va maslahatchilari bilan bog'liq bo'lmagan har qanday
              shaxslar yoki tashkilotlarga maxfiy ma'lumotlarni yoki uning bir
              qismini taqdim etiladi, huddi ular ushbu shartnoma tarafi
              bo'lgandek;
            </li>
            <li>
              maxfiy ma'lumotlardan, shu jumladan bosma nashrlarda, internetda
              va boshqa ma'lumot tarqatish manbalarida nashr etilishining oldini
              olish.
            </li>
          </ul>
          <p>
            13.3. Maxfiylikni saqlash majburiyatlari ushbu Shartnomaning amal
            qilish muddati tugaganidan keyin yoki muddatidan oldin bekor
            qilinganidan keyin keyingi 20 (yigirma) yil ichida ham o'z kuchini
            saqlab qoladi.
          </p>
          <p>
            13.4. Maxfiylik shartlarini buzgan tomon zarar ko'rgan tomonga
            to'g'ridan-to'g'ri yo'qotishlar va yo'qotilgan foyda miqdorida
            zararni qoplaydi.
          </p>
          <p>
            13.5. Tomonlarning milliy qonunchiligida ochiq ko'rsatilgan hollarda
            vakolatli davlat organlariga taqdim etilgan hollarda maxfiy
            ma'lumotlarni oshkor qilish deb hisoblanmaydi.
          </p>

          <h2 className="privacy__subtitle">
            14. MMTNING MANZILI VA REKVIZITLARI
          </h2>
          <p>Mikromoliya tashkiloti “PAYLATER” MChJ</p>
          <p>Manzil: Toshkent shahar, Mirobod tuman, Afrosiyob ko’ckasi, 14</p>
          <p>STIR: 309 776 769</p>
          <p>Aloqa markazi raqami:</p>
          <ul>
            <li>998 78 1137077</li>
            <li>998 78 1138488</li>
          </ul>
        </div>
      )}
    </>
  );
};
export default Paylater;
